import React from "react";
import { useNavigate } from "react-router-dom";
import { FiUser, FiCalendar, FiTag } from "react-icons/fi";
import fallbackImage from "../../assets/images/blogs/blog.svg";

const CATEGORY_LABELS = {
  mentalHealth: "Mental Health",
  therapy: "Therapy",
  relationships: "Relationships",
  personalGrowth: "Personal Growth",
  parentingFamily: "Parenting & Family",
  cultureIdentity: "Culture & Identity",
  onlineTherapy: "Online Therapy",
  selfCareWellbeing: "Self-Care & Wellbeing",
  forTherapists: "For Therapists",
};

const formatDate = (dateStr) => {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export default function BlogCard({ blog }) {
  const navigate = useNavigate();

  if (!blog) return null;

  const displayDate = formatDate(blog.publishDate || blog.createdAt);
  const excerpt = blog.destination || blog.summary || "";
  const category = CATEGORY_LABELS[blog.category] || blog.category || "";

  return (
    <div
      onClick={() => navigate(`/blog/${blog.id}`)}
      className="cursor-pointer bg-white border border-cards-border rounded-[30px] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col h-full"
    >
      {/* Cover Image */}
      <div className="w-full h-[200px] overflow-hidden flex-shrink-0 bg-gray-100">
        <img
          src={blog.coverImage || fallbackImage}
          alt={blog.title}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          onError={(e) => { e.target.src = fallbackImage; }}
        />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 p-5 gap-3">
        {/* Category badge */}
        {category && (
          <span className="inline-flex items-center gap-1.5 w-fit px-2.5 py-1 rounded-full bg-[#625480]/10 text-[#625480] text-xs font-medium">
            <FiTag className="w-3 h-3" />
            {category}
          </span>
        )}

        {/* Title */}
        <h3 className="font-poppins text-[18px] font-semibold text-text line-clamp-2 leading-snug">
          {blog.title}
        </h3>

        {/* Excerpt */}
        {excerpt && (
          <p className="font-poppins text-gray-500 text-[14px] line-clamp-3 leading-relaxed italic">
            {excerpt}
          </p>
        )}

        {/* Author + Date */}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-auto pt-3 border-t border-gray-100 text-xs text-gray-400">
          {blog.author && (
            <span className="flex items-center gap-1.5">
              <FiUser className="w-3.5 h-3.5" />
              {blog.author}
            </span>
          )}
          {displayDate && (
            <span className="flex items-center gap-1.5">
              <FiCalendar className="w-3.5 h-3.5" />
              {displayDate}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
